import React from 'react'
import Radium from 'radium'
import colors from '../../../../../../theme/colors'
import borderRadius from '../../../../../../theme/borderRadius'
import enabled from '../../lib/enabled'
import onClick from './lib/onClick'

const Component = ({
  form,
  field,
  baseName,
  isItem,
}) => (
  <div
    style={styles.container}
    onClick={onClick(form, baseName, isItem)}
  >
    <input
      id={field.name}
      type='checkbox'
      checked={enabled(form, baseName)}
      style={styles.input}
      {...field}
    />
    <div
      style={[
        styles.box,
        enabled(form, baseName) && styles.enabled.box,
      ]}
    />
    {enabled(form, baseName) && <div style={styles.mark} />}
  </div>
)

export default Radium(Component)

const styles = {
  container: {
    position: 'relative',
    display: 'flex',
    width: '20px',
    height: '20px',
    marginRight: '30px',
  },
  input: {
    opacity: 0,
    position: 'absolute',
  },
  box: {
    backgroundColor: colors.lightGrey,
    borderRadius,
    width: '20px',
    height: '20px',
    position: 'absolute',
  },
  mark: {
    position: 'absolute',
    left: '7px',
    top: '4px',
    width: '4px',
    height: '7px',
    borderColor: '#fff',
    borderStyle: 'solid',
    borderWidth: '0 2px 2px 0',
    transform: 'rotate(45deg)',
  },
  enabled: {
    box: {
      backgroundColor: colors.green,
    },
  },
}
